import React from 'react';
import MultiStepForm from './MultiStepForm';
import './MultiStepForm.css';

const Home = () => {
  return <MultiStepForm />;
};

export default Home; 